import TooltipCheckbox from "../../../components/tooltip/TooltipCheckbox"
import SimpleManaNode, { SimpleManaNodeOptions } from "./SimpleManaNode"

export type InvertableManaNodeOptions = { inverted?: boolean } & SimpleManaNodeOptions

export default class InvertableManaNode extends SimpleManaNode {

	inverted = false

	constructor({ inverted = false, ...rest }: InvertableManaNodeOptions) {
		super(rest)

		this.inverted = inverted
	}

	getSymbol() {
		return (this.inverted ? '❗' : '') + (this.constructor as any).nodeIcon
	}

	setInverted(inverted: boolean) {
		this.inverted = inverted
		this.reloadSymbol()
	}

	getTooltip() {

		return (
			<>
				{super.getTooltip()}
				<br />
				<TooltipCheckbox
					title="Inverted"
					initialChecked={this.inverted}
					onChange={inverted => this.setInverted(inverted)}
				/>
			</>
		)
	}

	save() {
		return {
			...super.save(),

			inverted: this.inverted,
		}
	}
}